<div class="modal-overlay" *ngIf="isOpen" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header" *ngIf="showHeader">
      <ng-content select="[modal-header]"></ng-content>
    </div>
    
    <div class="modal-body">
      <ng-content select="[modal-body]"></ng-content>
    </div>
    
    <div class="modal-footer" *ngIf="showFooter">
      <ng-content select="[modal-footer]"></ng-content>
    </div>
  </div>
</div> 